export default {
  initiated: state => state.initiated
}
